import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBoniversumIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 48,
		height: 48,
		rx: 8,
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M25.4033 13C27.4316 13 31.1338 14.4991 31.1338 17.9707C31.1338 21.0085 28.9848 22.4714 27.873 22.9414C29.0534 23.1802 32.3367 24.9974 32.3369 28.8301C32.3369 32.4377 29.0427 34.5928 27.1445 34.5928H16V13H25.4033ZM20.6123 25.3818V30.1807H24.4834C25.6236 30.1807 27.0797 29.3929 27.0537 27.7402C27.0274 26.088 25.3691 25.3819 24.5625 25.3818H20.6123ZM20.6123 21.0518H23.9082C24.8791 21.0518 26.1187 20.3817 26.0967 18.9746C26.0745 17.5674 24.6625 16.9658 23.9756 16.9658H20.6123V21.0518Z",
		fill: "#019FE0"
	})]
});
export default SvgBoniversumIcon;
